export enum ReviewRequestJustificationType {
  BugID,
  FreeText,
  NotApplicable
}
